
<template>
  <div>
    <dialog-loading
      v-if="updating_step"
      loadingText="Reordenando"
    ></dialog-loading>
    <div>
      <draggable 
        v-model="local_steps" 
        v-bind="dragOptions" 
        group="step"
        :class="[help_class]"
        @change="reorder" 
        @start="handleDragStart" 
        @end="handleDragStop" 
        :emptyInsertThreshold="50"
        :draggable="one_flow.status == 'draft'? '.aaa' : '.nada'" 
        :handle="one_flow.status == 'draft'? '.miojo' : '.nada'"
      >
        <transition-group 
          type="transition" 
          :name="!is_dragging ? 'flip-list' : null"
        >
          <div v-for="(step, idx) in local_steps" :key="step.id"  class="aaa miojo">
            <step-card
              :step="step"
              :idx="idx"
              :group_id="group_id"
            ></step-card>
          </div>
        </transition-group>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import draggable_helpers from '@/mixins/draggable_helpers'

export default {
  name: "StepList",
  mixins: [
    draggable_helpers
  ],
  props: {
    group_id: {
      type: Number,
      default: () => null 
    },
  },
  components: {
    StepCard: () => import('./StepCard.vue'),
  },
  data() {
    return {
      local_steps: null,
      updating_step: false
    }
  },
  mounted () {
    this.orderStepsFromGroup();
  },
  methods: {
    reorder(e) {
      setTimeout(() => {
        if (!this.is_dragging) {
          let step_to_update = null;
          
          if (e.moved) {
            this.updating_step = true;
            step_to_update = this.moveStep({...e.moved.element});    
          } else if (e.added) {
            this.updating_step = true;
            step_to_update = this.addStep({...e.added.element})
          }
    
          if (step_to_update) {
            // console.log("step_to_update_next => ", step_to_update.next );
            // console.log("step_to_update_previous => ", step_to_update.previous );
            this.updateStep(step_to_update).then(() => {
              this.updating_step = false;
            });
          }
        }
      }, 500);
    },
    removeStepFromPreviousGroup(step) {
      let previous_group = this.all_groups.find((group) => group.id === step.group_id);

      const step_idx = previous_group.steps.findIndex((st) => st.id === step.id);

      previous_group.steps.splice(step_idx, 1);

      this.setGroup(previous_group);
    },
    addStep(step_to_add) {
      let step_to_update = {...step_to_add};
      const step_to_update_idx = this.local_steps.findIndex((step) => step.id === step_to_update.id);
      const previous_step = this.local_steps[step_to_update_idx - 1];
      const next_step = this.local_steps[step_to_update_idx + 1];
      
      // console.log("step_to_update => ", step_to_update );
      // console.log("step_to_update_idx => ", step_to_update_idx );
      // console.log("previous_step => ", previous_step && previous_step.name );
      // console.log("next_step => ", next_step && next_step.name );
      
      if (!previous_step && !next_step) {
        this.removeStepFromPreviousGroup(step_to_update);
        
        const current_group_idx = this.ordered_groups.findIndex(({id})=> id == this.group_id);

        let group_has_step = false;
        let previous_group_idx = current_group_idx - 1;
        let next_group_idx = current_group_idx + 1;

        while (!group_has_step) {
          let previous_group = null;
          let next_group = null;
          let previous_step_from_another_group = null;
          let next_step_from_another_group = null;

          if (previous_group_idx >= 0) {
            previous_group = this.ordered_groups[previous_group_idx];
          }
          if (next_group_idx < this.ordered_groups.length) {
            next_group = this.ordered_groups[next_group_idx];
          }

          if (previous_group && previous_group.steps && previous_group.steps.length) {
            // console.log("entrou no previous")
            // console.log("previous_group => ", previous_group);
            previous_step_from_another_group = {...previous_group.steps[previous_group.steps.length - 1]};

            if (previous_step_from_another_group.siblings && previous_step_from_another_group.siblings.length) 
              step_to_update.previous = [...previous_step_from_another_group.siblings, previous_step_from_another_group.id];
            else 
              step_to_update.previous = [previous_step_from_another_group.id];
  
            if (!previous_step_from_another_group.next.includes(step_to_update.id))
              step_to_update.next = [...previous_step_from_another_group.next];

            group_has_step = true;
          } else if (next_group && next_group.steps && next_group.steps.length) {
            // console.log("entrou no next")
            // console.log("next_group => ", next_group);
            next_step_from_another_group = {...next_group.steps[0]};

            if (next_step_from_another_group.siblings && next_step_from_another_group.siblings.length) 
              step_to_update.next = [...next_step_from_another_group.siblings, next_step_from_another_group.id];
            else 
              step_to_update.next = [next_step_from_another_group.id];
  
            if (!next_step_from_another_group.previous.includes(step_to_update.id))
              step_to_update.previous = [...next_step_from_another_group.previous];

            group_has_step = true;
          }

          previous_group_idx -= 1;
          next_group_idx += 1;
        }
      } else if (previous_step) {
        if (previous_step.siblings && previous_step.siblings.length) 
          step_to_update.previous = [...previous_step.siblings, previous_step.id];
        else 
          step_to_update.previous = [previous_step.id];

        if (!previous_step.next.includes(step_to_update.id)) {
          step_to_update.next = [...previous_step.next];
        }

      } else if (next_step) {
        if (next_step.siblings && next_step.siblings.length) 
          step_to_update.next = [...next_step.siblings, next_step.id];
        else 
          step_to_update.next = [next_step.id];

        if (!next_step.previous.includes(step_to_update.id)) {
          step_to_update.previous = [...next_step.previous];
        }
      }
      
      step_to_update.group_id = this.group_id;

      return step_to_update;
    },
    moveStep(step_to_move) {
      let step_to_update = {...step_to_move};
      const step_to_update_idx = this.local_steps.findIndex((step) => step.id === step_to_update.id);
      const previous_step = this.local_steps[step_to_update_idx - 1];
      const next_step = this.local_steps[step_to_update_idx + 1];

      if (previous_step) {
        if (previous_step.siblings && previous_step.siblings.length) 
          step_to_update.previous = [...previous_step.siblings, previous_step.id];
        else 
          step_to_update.previous = [previous_step.id];

        step_to_update.next = [...previous_step.next];
      }

      if (next_step) {
        if (next_step.siblings && next_step.siblings.length) 
          step_to_update.next = [...next_step.siblings, next_step.id];
        else 
          step_to_update.next = [next_step.id];

        step_to_update.previous = [...next_step.previous];
      }

      return step_to_update;
    },
    orderStepsFromGroup() {
      this.local_steps = [];
      const group = this.all_groups.find((group) => group.id == this.group_id);
      const steps = group.steps;

      if (steps && steps.length) {
        let first_step = steps.find((step) => step.id == group.first_step_id);
        this.local_steps.push(first_step);
        let current = first_step;
  
        while(current && current.next.length && group.steps.length > 1) {
          let next = steps.find((step) => step.id == current.next[0]);
          if (next) {
            this.local_steps.push(next);
            current = next;
          } else {
            current = null;
          }
        }
      }
    },
    ...mapMutations({
      setGroup: "ConfigFlow/setGroup"
    }),
    ...mapActions({
      updateStep: "ConfigFlow/updateStep"
    })
  },
  computed: {
    help_class(){
      return this.local_steps.length > 0? '' : 'bacon'
    },
    ...mapGetters({
      ordered_groups: "ConfigFlow/orderedGroups"
      // current_group: "ConfigFlow/currentGroup"
      // steps: 'ConfigFlow/orderedStepsFromCurrentGroup',
      // orderedStepsByGroup: "ConfigFlow/orderedStepsByGroup"
    }),
    ...mapState({
      all_steps: state => state.ConfigFlow.all_steps,
      all_groups: state => state .ConfigFlow.all_groups,
      one_flow: state => state.ConfigFlow.one_flow
    })
  },
  watch: {
    all_steps: {
      deep: true,
      immediate: true,
      handler(nv){
        if (nv) {
          this.orderStepsFromGroup();
        }
      }
    }
  },
}
</script>

<style scoped>
.bacon span {
  display: block; 
  height: 100%;
}
</style>